import React from 'react';
import './App.css';

function BooksThankYou() {
  return (
    <div className="main-bg">
      <header className="hero-section">
        <h1 className="site-title">Thank You!</h1>
        <p className="site-tagline">Your purchase was successful.</p>
      </header>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default BooksThankYou; 